export var subTitle = 'flex flex-row justify-start items-center';
export var chevronIcon = 'h-22 w-22 text-textLight';
export var container = function (backgroundColor, withPaddingY, withPaddingX, withBorderRadius, showDivider, dividerType, dividerColor) {
    return "flex flex-row justify-between items-center bg-".concat(backgroundColor, " cursor-pointer ").concat(withBorderRadius ? 'rounded-10' : '', " ").concat(withPaddingY ? 'py-4' : '', " ").concat(withPaddingX ? 'px-4' : '', "\n   ").concat(showDivider ? "border-t border-".concat(dividerColor, " border-").concat(dividerType) : '', "\n  ");
};
export var getShapeClass = function (type, subTitleColor) {
    switch (type) {
        case 'square':
            return "h-2.5 w-2.5 bg-".concat(subTitleColor);
        case 'triangle':
            return "h-0 w-0 border-opacity-0 border-t-0 border-l-5 border-l-tranparent border-r-5 border-r-tranparent border-b-10 border-b-".concat(subTitleColor, " shadow-none");
        case 'circle':
            return "h-2.5 w-2.5 rounded-full bg-".concat(subTitleColor);
        default:
            return "h-2.5 w-2.5 rounded-full bg-".concat(subTitleColor);
    }
};
//# sourceMappingURL=list-item.styles.js.map